module.exports = '<svg width="35" height="32" viewBox="0 0 35 32"><path d="M9.315 4.302L1.831.564C.821.059 0 .564 0 1.694v22.481c0 1.13 0 2.044 1.837 2.957l7.47 3.738c.509.253.911 0 .911-.564V5.782c0-.564-.399-1.226-.903-1.48zM25.448 1.13c-.505-.251-.924 0-.924.564v24.524c0 .564.419 1.228.924 1.48l7.47 3.738c1.01.505 1.825 0 1.825-1.13V7.825c0-1.13 0-2.044-1.825-2.957l-7.47-3.738zM22.035.006a1.595 1.595 0 0 0-.417.172l-8.471 5.079c-.486.29-.885.983-.885 1.547v24.234c0 .564.219 1.018.466.956a1.61 1.61 0 0 0 .425-.172l8.461-5.079c.482-.29.867-.983.867-1.547V.962c0-.566-.2-1.018-.446-.956z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/map-1.js
// module id = 1255
// module chunks = 14